import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import './DeclineModal.css';
import DeclineForm, {
  REASON_OPTIONS,
} from 'components/shared/modal/DeclineForm';
import PropTypes from 'prop-types';
import numeral from 'numeral';

export default class DeclineModal extends Component {
  static propTypes = {
    show: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
  };

  static defaultProps = {
    show: false,
  };

  handleOnSubmit = (values) => {
    this.props.onSubmit({
      ...values,
      reason: REASON_OPTIONS[numeral(values.reason).value()],
    });
  };

  render() {
    return (
      <Modal className="decline-modal" show={this.props.show}>
        <Modal.Body>
          <DeclineForm onSubmit={this.handleOnSubmit} />
        </Modal.Body>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/modal/DeclineModal.js